import React from 'react';
import { Button, Stack } from '@mui/material';
import clsx from 'clsx';
import { ConversationQuestion, CTAOption } from '../../../data-access';
import { ChatMarkdown } from '../../common';
import './ConversationQuestionCard.scss';

interface ConversationQuestionCardProps {
  question: ConversationQuestion;
  onSelect: (option: CTAOption) => void;
  disabled?: boolean;
}

const ConversationQuestionCard: React.FC<ConversationQuestionCardProps> = ({
  question,
  onSelect,
  disabled = false,
}) => {
  return (
    <Stack className="conversation-question-card" gap={1.5}>
      <ChatMarkdown content={question.context} className="conversation-question-card__context" />
      <ChatMarkdown content={question.question} className="conversation-question-card__question" />
      <Stack gap={1} className="conversation-question-card__options">
        {question.options.map((option, i) => (
          <Button
            key={i}
            variant={option.style === 'primary' ? 'contained' : 'outlined'}
            className={clsx('conversation-question-card__option', {
              [`conversation-question-card__option--${option.style}`]: true,
              'conversation-question-card__option--disabled': disabled,
            })}
            onClick={() => !disabled && onSelect(option)}
            disabled={disabled}
          >
            {option.label}
          </Button>
        ))}
      </Stack>
    </Stack>
  );
};

export default ConversationQuestionCard;
